// extracted by mini-css-extract-plugin
var _1 = "ToolbarSyntaxButton-module__container--F0OB5";
export { _1 as "container" }
